import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { selectAppMode } from '@store/global/selectors';
import { AppModeEnum } from '@project-types/AppModeEnum';
import { LoadingPage } from '@pages/loading-page/LoadingPage';
import { ErrorPage } from '@pages/error-page/ErrorPage';
import { useAppLogic } from '@layouts/app-logic/useAppLogic';



const AppLogic = () => {

	const appMode = useSelector(selectAppMode);

	useAppLogic();

	if (appMode === AppModeEnum.initDataFailed ||
		appMode === AppModeEnum.appFailed ||
		!appMode) return (
			<ErrorPage />
	);

	if (appMode === AppModeEnum.appSuccess) return (
		<Outlet />
	);

	return (
		<LoadingPage />
	);
};

export default AppLogic;